import React from "react";
import styled from "@emotion/styled";
import { Drawer } from "antd5";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import { CreateOpportunityForm, CreateOpportunityFormValues } from "./CreateOpportunityForm";

type Props = {
  defaultValues?: Partial<CreateOpportunityFormValues>;
  onClose: () => void;
  isOpen: boolean;
  hiddenFields?: (keyof CreateOpportunityFormValues)[];
  navigateToNewOpportunity?: boolean;
};

export function CreateOpportunityDrawer({
  isOpen,
  defaultValues,
  hiddenFields,
  onClose,
  navigateToNewOpportunity,
}: Props) {
  return (
    <Drawer
      placement="right"
      open={isOpen}
      width={486}
      onClose={(event) => {
        event.stopPropagation();
        onClose();
      }}
      styles={{ header: { display: "none" }, body: { padding: "24px" } }}
      onClick={(event) => {
        // Prevent the drawer from propagating click events to the parent e.g. row click
        event.stopPropagation();
      }}
    >
      <FormContent>
        <Flex justifyContent="space-between" alignItems="center">
          <Text h2>Create new opportunity</Text>
          <Button icon="xClose" iconProps={{ size: 16 }} buttonType="tertiary" onClick={onClose} />
        </Flex>
        <CreateOpportunityForm
          defaultValues={{
            ...defaultValues,
            assignedToId: window.currentUser?.guid,
          }}
          hiddenFields={hiddenFields}
          onComplete={onClose}
          navigateToNewOpportunity={navigateToNewOpportunity}
        />
      </FormContent>
    </Drawer>
  );
}

const FormContent = styled(Flex)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flexGrow: 1,
  gap: 24,
});
